export const LONG_STALE_TIME = 1000 * 60 * 30; // 30 minutes
export const GREEN_ID_TOKEN_EXPIRY_TIME = 1000 * 60 * 30; // 30 minutes
